<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter"
      :style="headerStyle"
    ></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 mx-auto">
              <div class="profile">
                <div class="avatar">
                  <img
                    :src="img"
                    alt="Circle Image"
                    class="img-raised rounded-circle img-fluid"
                  />
                </div>
                <div class="name">
                  <h3 class="title">Nick van Bruggen</h3>
                  <h6>Webdeveloper</h6>
                </div>
              </div>
            </div>
          </div>
          <div class="description text-center">
            <p>
              In my spare time I like to develop websites! I love to work with
              VueJS, but I also create websites with Wordpress and Magento 2.
              <br />
              Check out my work below!
            </p>
          </div>
          <div class="profile-tabs">
            <tabs
              :tab-name="['Wordpress', 'Magento2', 'VueJS']"
              :tab-icon="['palette', 'camera', 'favorite']"
              plain
              nav-pills-icons
              color-button="success"
            >
              <!-- here you can add your content for tab-content -->
              <template slot="tab-pane-1">
                <div class="md-layout">
                  <div class="md-layout-item md-size-50 ml-auto">
                    <!-- PDSM -->
                    <img :src="tabPane1[0].image" class="rounded" />
                    <div class="description text-center">
                      <p>
                        <a
                          href="https://www.pure-dead-sea-minerals.nl/"
                          target="_blank"
                          >Pure Dead Sea Minerals</a
                        >
                        <br />
                        A webshop for products from the Dead Sea!
                      </p>
                    </div>

                    <!-- Mystis -->
                    <img :src="tabPane1[1].image" class="rounded" />
                    <div class="description text-center">
                      <p>
                        <a href="https://mayena.nl/" target="_blank">Mayena</a>
                        <br />
                        A webshop for a clothing brand famous from TikTok!
                      </p>
                    </div>
                  </div>
                  <div class="md-layout-item md-size-50 mr-auto">
                    <!-- Mayena -->
                    <img :src="tabPane1[2].image" class="rounded" />
                    <div class="description text-center">
                      <p>
                        <a href="https://mystis.nl/" target="_blank">Mystis</a>
                        <br />
                        A webshop for a new starting clothing brand!
                      </p>
                    </div>
                  </div>
                </div>
              </template>
              <template slot="tab-pane-2">
                <div class="md-layout">
                  <div class="md-layout-item md-size-50 ml-auto">
                    <!-- VSO -->
                    <img :src="tabPane2[0].image" class="rounded" />
                    <div class="description text-center">
                      <p>
                        <a href="https://vechtsportonline.nl/" target="_blank"
                          >Vechtsportonline</a
                        >
                        <br />
                        At Vechtsportonline I worked as a freelancer to help
                        develop the new website in Magento 2. I have developed
                        the largest part of the website at the frontend area
                        based on a design.
                      </p>
                    </div>
                    <!-- <img :src="tabPane2[1].image" class="rounded" /> -->
                  </div>
                  <div class="md-layout-item md-size-50 mr-auto">
                  </div>
                </div>
              </template>
              <template slot="tab-pane-3">
                <div class="md-layout">
                  <div class="description text-center">
                    <p>
                      I haven't made a VueJS website for a client yet.. But the
                      website you are looking at is made with VueJS!
                    </p>
                  </div>
                  <div class="md-layout-item md-size-50 ml-auto">
                  </div>
                  <div class="md-layout-item md-size-50 mr-auto">
                  </div>
                </div>
              </template>
            </tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tabs } from "@/components";
export default {
  components: {
    Tabs
  },
  bodyClass: "profile-page",
  data() {
    return {
      tabPane1: [
        { image: require("@/assets/img/portfolio/PDSM.jpg") },
        { image: require("@/assets/img/portfolio/MAYENA.jpg") },
        { image: require("@/assets/img/portfolio/MYSTIS.jpg") }
      ],
      tabPane2: [
        { image: require("@/assets/img/portfolio/VSO.jpg") }
      ],
      tabPane3: [
        { image: require("@/assets/img/portfolio/PDSM.jpg") }
      ]
    };
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/city-profile.jpg")
    },
    img: {
      type: String,
      default: require("@/assets/img/faces/travel.jpg")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
// import {Modal} from '@/components';
// export default {
//   components: {
//     Tabs
//   },
//   bodyClass: "",
//   data() {
//     return {
//     };
//   },
// };
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}
</style>
